module.exports = __webpack_public_path__ + "static/img/blue-house.7979d81.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/blue-house.jpg
// module id = hKPj
// module chunks = 0